module.exports = __webpack_public_path__ + "img/arrow.64c224f4.svg";